export default __webpack_public_path__ + "static/media/e835cd2877dfa2a5172332262e2ee2361602891226278.1fbefda2.webp";